import { render, staticRenderFns } from "./AdyenBlikForm.vue?vue&type=template&id=0ffb17ac"
import script from "./AdyenBlikForm.vue?vue&type=script&lang=js"
export * from "./AdyenBlikForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports